module.exports = __webpack_public_path__ + "media/days.daac9236.mp3";